import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import OutgoingSummaryFormHandle from '@Modules/reporting/containers/forms/visaBase2/outgoingSummary/OutgoingSummaryFormHandle';
import IncomingSummaryFormHandle from '@Modules/reporting/containers/forms/visaBase2/incomingSummary/IncomingSummaryFormHandle';
import VisaDetailsOutgoing from '@Modules/reporting/pages/visaBase2/VisaDetailsOutgoing';
import VisaDetailsIncoming from '@Modules/reporting/pages/visaBase2/VisaDetailsIncoming';

const VisaBase2 = () => {
  return (
    <div>
      <CC.Text fontSize={20} fontWeight="bold" mb="4">
        Visa Base II
      </CC.Text>

      <CC.Tabs orientation='vertical'>
          <CC.TabList borderRight={'1px solid lightgray'} alignItems={'start'} textAlign={'start'}>
            <CC.Tab
              minWidth={'fit-content'}>
                Résumé sorties
            </CC.Tab>
            <CC.Tab
              minWidth={'fit-content'}>
                Résumé entrées
            </CC.Tab>
            <CC.Tab
              textAlign={'left'}
              minWidth={'fit-content'}>
                Données VISA sortantes
            </CC.Tab>
            <CC.Tab
              textAlign={'left'}
              minWidth={'fit-content'}>
                Données VISA entrantes
            </CC.Tab>
          </CC.TabList>

        <CC.TabPanels>

          <CC.TabPanel>
            <OutgoingSummaryFormHandle />
          </CC.TabPanel>
          <CC.TabPanel>
            <IncomingSummaryFormHandle />
          </CC.TabPanel>
          <CC.TabPanel>
            <VisaDetailsOutgoing />
          </CC.TabPanel>
          <CC.TabPanel>
            <VisaDetailsIncoming />
          </CC.TabPanel>

        </CC.TabPanels>
      </CC.Tabs>

    </div>
  )
}

export default VisaBase2;